import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { titleStyle } from '../../utils/commonCSS'
import { headingBlue, maroon, pureWhite, red } from '../../assets/colors';
import { updateLeadAssignedToWORKer, updateReferalLeadStatus } from '../../backend/backendApis';
import { leadStatus } from '../../utils/constants';
import HttpService from '../../backend/requestApis';
import { CheckBox } from '@mui/icons-material';
import CustomLeadsRating from '../CustomLeadsRating';
import CustomTextField from '../CustomTextField';
import Loader from '../Loader';
import { errorStyleText } from '../formStyle';
import { useNavigate } from 'react-router-dom';

const UpdateWORKersLead = (props) => {

    const navigate = useNavigate()

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const [selectedCallStatus, setSelectedCallStatus] = useState(props?.data?.leadStatus);
    const [fields, setFields] = useState(props?.data?.fields)
    const [remarks, setRemarks] = useState(props?.data?.remarks)
    const [leadResponseValue, setLeadResponseValue] = useState(props?.data?.leadResponse)
    const [loader, setLoader] = useState(false)
    const [apiError, setApiError] = useState('')
    const [closedApiError, setClosedApiError] = useState('')

    const updateRemarks = (remarks) => {
        if( remarks.length < 150)
            setRemarks(remarks)
    }

    const uploadFields = (id, value) => {
        setFields(prevFields => 
        prevFields?.map((field) => 
            field.id === id ? { ...field, value } : field
        ))
    }

    const updateLeadStatus = (status) => {
        setSelectedCallStatus(status)
    }

    const updateLead = () => {
        setLoader(true)
        if( selectedCallStatus === 'followUp'){
            setSelectedCallStatus(() => 'followUp')
            setLoader(false)
        } else{
            let options = {
                url: updateReferalLeadStatus,
                method: 'PUT',
                payload: {
                    _id: props?.data?._id,
                    leadStatus: selectedCallStatus
                },
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null,
                    "Content-Type": "application/json",
                },
            }
            HttpService(options).then((resp) => {
                props.updateDialogStatus(true)
                setLoader(false)
            }).catch(err => {
                if (err?.status === 403) {
                    navigate('/signUp')
                    setLoader(false)  
                } else {
                    setApiError('Error in updating Lead.', err)
                    setLoader(false)
                }
            })
        }
    }

    const closeLead = () => {
        setLoader(true)
        let options = {
            url: updateLeadAssignedToWORKer,
            method: 'POST',
            payload: {
                id: props?.data?._id,
                fields: fields,
                leadStatus: leadResponseValue ? 'closed' : selectedCallStatus ,
                leadResponse: leadResponseValue,
                remarks: remarks
            },
            headers: {
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
        }
        HttpService(options).then((resp) => {
            console.log("Lead Updated.")
            props?.updateDialogStatus(true)
            setLoader(false)
        }).catch(err => {
            if (err?.status === 403) {
              navigate('/signUp')
              setLoader(false)  
            } else {
                console.log("Error: ", err)
                setClosedApiError('Error in updating Lead. Please Contact Support.')
                setLoader(false)
            }
        })
    }

    const handleReset = () => {
        setLoader(true)
        setSelectedCallStatus(props?.data?.leadStatus)
        setFields(props?.data?.fields)
        setLeadResponseValue(props?.data?.leadResponse)
        setRemarks(props?.data?.remarks)
        setApiError('')
        setClosedApiError('')
        setLoader(false)
    }

    useEffect(() => {
        setLoader(true)
        setSelectedCallStatus(props?.data?.leadStatus)
        setFields(props?.data?.fields)
        setLeadResponseValue(props?.data?.leadResponse)
        setRemarks(props?.data?.remarks)
        setApiError('')
        setClosedApiError('')
        setLoader(false)
    }, [props])
    
  return (
    <>
        <Dialog maxWidth = 'xs' fullWidth open={props.dialogStatus} onClose= {() => props.updateDialogStatus()}>
            <DialogTitle style={{...titleStyle}}> 
                Lead Details
            </DialogTitle>
            <DialogContent style={{
					textAlign: "center",
					marginTop: "0.7rem",
				}}>
                <Box
					sx={{
						display: "grid",
						gridTemplateColumns: "2.1fr 0.8fr 1.6fr 1.5fr",
						gap: "0.5rem",
						padding: "0.2rem 0rem 0rem 0rem",
						color: maroon,
						alignItems: 'center'
					}}
				>
					<Typography sx={{ textAlign: 'left', fontSize: isMobile ? "0.8rem" : "0.9rem" }}>
						{props?.data?.name}
					</Typography>
					<Typography sx={{textAlign: 'center',fontSize: isMobile ? "0.8rem" : "0.9rem" }}>
						{props?.data?.age ? `${props?.data?.age} Y` : '-'}
					</Typography>
					<Typography sx={{textAlign: 'center', fontSize: isMobile ? "0.8rem" : "0.9rem" }}>
						{props?.data?.district}
					</Typography>
					<Typography sx={{textAlign: 'right', fontSize: isMobile ? "0.8rem" : "0.9rem",  }}  component='a' href={`tel:${props?.data?.contactNumber}`}>
						{props?.data?.contactNumber}
					</Typography>
				</Box>
                {loader && <Loader></Loader>}
                {(!selectedCallStatus || selectedCallStatus === 'wrongNumber' || selectedCallStatus === 'notReachable') ?
                    <>
                        <Box sx={{ textAlign: "left", marginTop: "0.7rem" }}>
                            <Typography style={{color: maroon}}>Call Initiated</Typography>
                            <Box sx={{display: "flex",flexDirection: "column", margin: 0, padding: 0, color: headingBlue }}>
                                <FormControl>
                                    <RadioGroup value = {selectedCallStatus}
                                        sx={{ flexDirection: "column", padding: '0rem'}}
                                        onChange={(e) => updateLeadStatus(e?.target?.value)}
                                    >
                                        <FormControlLabel
                                            value="wrongNumber"
                                            control={<Radio sx={{ padding:"0.2rem 0rem 0rem 0.5rem", transform: "scale(0.8)" }} />}
                                            label={
                                                <span style={{ fontSize: "0.9rem" }}>Wrong Number</span>
                                            }
                                            style={{ margin: 0, padding: "0rem 0rem 0rem 0rem"  }}
                                            // style={{border: '1px solid' }}
                                        />
                                        {/* <FormControlLabel
                                            value="wrongDistrict"
                                            control={<Radio sx={{padding:"0.2rem 0rem 0rem 0.5rem", transform: "scale(0.8)" }} />}
                                            label={
                                                <span style={{ fontSize: "0.9rem" }}>Wrong Information</span>
                                            }
                                            style={{ margin: 0, padding: 0 }}
                                        /> */}
                                        <FormControlLabel
                                            value="notReachable"
                                            control={<Radio sx={{padding:"0.2rem 0rem 0rem 0.5rem", transform: "scale(0.8)" }} />}
                                            label={
                                                <span style={{ fontSize: "0.9rem" }}>Not reachable</span>
                                            }
                                            style={{ margin: 0, padding: 0 }}
                                        />
                                        <FormControlLabel
                                            value="followUp"
                                            control={<Radio sx={{padding:"0.2rem 0rem 0rem 0.5rem", transform: "scale(0.8)" }} />}
                                            label={<span style={{ fontSize: "0.9rem" }}>Follow Up</span>}
                                            style={{ margin: 0, padding: 0 }}
                                        />
                                        {/* <FormControlLabel
                                            value="wrongDistrict"
                                            control={<Radio sx={{padding:"0.2rem 0rem 0rem 0.5rem", transform: "scale(0.8)" }} />}
                                            label={<span style={{ fontSize: "0.9rem" }}>Wrong District</span>}
                                            style={{ margin: 0, padding: 0 }}
                                        /> */}

                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Box>

                        <Box sx={{
                            display: "flex",
                            alignItems: 'center',
                            justifyContent: "center",
                            padding: '0.5rem 0rem 0rem 0rem'
                        }}>
                            <Button sx={{
                                border: "1px solid",
                                borderColor: headingBlue,
                                backgroundColor: headingBlue,
                                color: pureWhite,
                                fontSize: "0.8rem",
                            }}
                            onClick={() => {
                                updateLead()
                            }}
                            > Update Lead

                            </Button>

                        </Box>
                        {apiError && 
                            <Typography style={{...errorStyleText, marginTop: '0.5rem'}}>{apiError}</Typography>
                        }

                    </> :
                    <>
                        {(selectedCallStatus === 'followUp' || selectedCallStatus === 'closed') ?
                            <>
                                <Box style={{padding: "1rem 0rem 0.5rem 0rem"}}>
                                    {fields?.map(option => {
                                        return selectComponent(option.name, option.value, option.id, uploadFields)
                                    })}
                                </Box>
                                <Divider></Divider>
                                <Box sx={{
                                        display: "flex",
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: 0,
                                        padding: "0.5rem 0.2rem 0.4rem 0.2rem",
                                        color: headingBlue,
                                        // height: '30vh',
                                        // overflow: 'auto'
                                    }}>
                                    <CustomTextField  isMultiline={true} width='18rem' placeHolder='Remarks' value={remarks} setFunc={updateRemarks}></CustomTextField>
                                </Box>
                                <Box sx={{
                                        display: "flex",
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: 0,
                                        padding: "0.4rem",
                                        color: headingBlue,
                                        // height: '30vh',
                                        // overflow: 'auto'
                                    }}>
                                    <CustomLeadsRating value={leadResponseValue} valueFunc={setLeadResponseValue}></CustomLeadsRating>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: 'center',
                                        justifyContent: "center",
                                        padding: '0.5rem 0rem 0rem 0rem'
                                    }}
                                >
                                    <Button
                                        sx={{
                                            border: "1px solid",
                                            borderColor: red,
                                            backgroundColor: red,
                                            color: pureWhite,
                                            fontSize: "0.8rem",
                                            marginRight: "0.5rem"
                                        }}
                                        onClick={() => handleReset()}
                                        >
                                        Previous
                                    </Button>
                                    <Button
                                        sx={{
                                            border: "1px solid",
                                            borderColor: headingBlue,
                                            backgroundColor: headingBlue,
                                            color: pureWhite,
                                            fontSize: "0.8rem",
                                        }}
                                        onClick={() => closeLead()}
                                        // onClick={() => handleAcceptedRejected()}
                                    >
                                        Update Lead
                                    </Button>
                                </Box>

                                {closedApiError && 
                                    <Typography style={{...errorStyleText, marginTop: '0.5rem'}}>{closedApiError}</Typography>
                                }
                            </> : 
                            (selectedCallStatus === 'wrongDistrict') && 
                                <>
                                    <Typography> Wrong District Code</Typography>
                                </>
                            
                            
                        } 
                    </>
                
                }

            </DialogContent>
        </Dialog>
    </>
  )
}

function selectComponent(title, value, _id, uploadFields){
    return(
        <>
            <Box style={{display: 'flex', flexDirection: 'row'}}>
                <Checkbox style={{ padding: '0rem 0.1rem 0rem 0.1rem'}}
                    checked={value}
                    onChange={() => {
                        uploadFields(_id, !value)
                    }}
                >

                </Checkbox>
                <Typography sx={{fontSize: '0.9rem',color: headingBlue}}>{title?.label ? title?.label : title}</Typography>
            </Box>
            
        </>
    )
}

export default UpdateWORKersLead
